import { SharedLanguageService } from '@language';

export function getLanguageByLocale(translateService: SharedLanguageService, languageCode: string): string {
    const language = languageCode.split('_')[0];
    const country = languageCode.split('_')[1];

    const languageTranslation = translateService.instant('languages.' + language);
    const countryIcon = getFlagEmoji(country);

    return `${countryIcon} ${languageTranslation}`;
}

// Build a flag emoji from a country code
export function getFlagEmoji(countryCode: string): string {
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
}
